import React, { Component } from 'react';
import {
  Alert,
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Glyphicon,
  Panel,
  Checkbox,
  Row,
  Clearfix,
  InputGroup
} from "react-bootstrap";

import FormSectionStatus from './FormSectionStatus';

import { educationalGoalOptions, statusTypes } from "../config/constants";
import { debugLog } from "../libs/app";

class EducationInfo extends Component {
  constructor(props){
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeHSName = this.handleChangeHSName.bind(this);
    this.handleChangeCollegeName = this.handleChangeCollegeName.bind(this);
    this.handleChangeDegreeName = this.handleChangeDegreeName.bind(this);
  }

  handleToggle(key) {
    if(this.props.readOnly)
      return;
    let updates = {};
    updates[key] = !this.props[key];
    this.props.onChange(updates);
  }

  handleChange(e) {
    if(this.props.readOnly)
      return;
    debugLog(e.target.name);
    let updates = {};
    updates[e.target.name] = e.target.value;
    this.props.onChange(updates);
  }

  handleChangeHSName(e) {
    if(this.props.readOnly)
      return;
    const updates = { hsName: e.target.value };
    this.props.onChange(updates);
  }

  handleChangeCollegeName(e) {
    if(this.props.readOnly)
      return;
    const updates = { name: e.target.value };
    const id = e.target.name;
    this.props.onUpdateCollege(id, updates);
  }

  handleChangeDegreeName(e) {
    if(this.props.readOnly)
      return;
    const updates = { name: e.target.value };
    const id = e.target.name;
    this.props.onUpdateDegree(id, updates);
  }

  render() {
    const {
      hsName,
      hsGpa,
      hsDiploma,
      hsGed,
      hsForeignDiploma,
      colleges,
      collegeMajor,
      collegeUnits,
      degrees,
      validationStatus,
      readOnly
    } = this.props;
    const space = ' ';

    const renderColleges = () => {
      if(colleges.length === 0) {
        return (
          <Alert bsStyle="warning">
            No colleges listed
          </Alert>
        )
      }

      return colleges.map((college, index) => {
        return (
          <FormGroup
            key={college.id}
            controlId={`college-${college.id}-name`}>
            <ControlLabel>
              College {index + 1}
            </ControlLabel>
            <InputGroup>
            <FormControl
              componentClass="input"
              name={college.id}
              type="text"
              value={college.name}
              placeholder="College Name"
              onChange={this.handleChangeCollegeName} />
            <FormControl.Feedback />
            <InputGroup.Button>
              <Button bsStyle='default'
                      onClick={() => this.props.onRemoveCollege(college.id)}>
                <Glyphicon glyph="remove" />
                {space} Remove
              </Button>
            </InputGroup.Button>
          </InputGroup>
          </FormGroup>
        );
      });
    };

    const renderDegrees = () => {
      if (degrees.length === 0) {
        return (
          <Alert bsStyle="warning" key='1'>
            No degrees listed
          </Alert>
        );
      }

      return degrees.map((degree, index) => {
        return (
          <FormGroup
            key={degree.id}
            controlId={`degree-${degree.id}-name`}>
            <ControlLabel>
              Degree {index + 1}
            </ControlLabel>
            <InputGroup>
            <FormControl
              componentClass="input"
              name={degree.id}
              type="text"
              value={degree.name}
              placeholder="Degree Name"
              onChange={this.handleChangeDegreeName}/>
            <FormControl.Feedback/>
              <InputGroup.Button>
                <Button bsStyle='default'
                        onClick={() => this.props.onRemoveDegree(degree.id)}>
                  <Glyphicon glyph="remove" />
                  {space} Remove
                </Button>
              </InputGroup.Button>
            </InputGroup>
          </FormGroup>
        );
      });
    };

    return (
      <Panel bsStyle={validationStatus.section.status}>
        <Panel.Heading>Education Information</Panel.Heading>
        <Panel.Body>
          <h4>High School</h4>
          <Row>
            <Col md={6}> {/* High School Name */}
              <FormGroup
                controlId='high-school-name'
                validationState={validationStatus.hsName}>
                <ControlLabel>
                  High School Name
                </ControlLabel>
                <FormControl
                  componentClass="input"
                  name='hsName'
                  type="text"
                  value={hsName}
                  placeholder="Name of High School"
                  onChange={this.handleChangeHSName} />
                <FormControl.Feedback />
              </FormGroup>
            </Col> {/* High School Name */}
            <Col md={2}> {/* High School GPA */}
              <FormGroup
                controlId='high-school-gpa'
                validationState={validationStatus.hsGpa}>
                <ControlLabel>
                  High School GPA
                </ControlLabel>
                <FormControl
                  componentClass="input"
                  name='hsGpa'
                  type="text"
                  value={hsGpa}
                  placeholder="GPA"
                  onChange={this.handleChange} />
                <FormControl.Feedback />
              </FormGroup>
            </Col> {/* High School GPA */}
            <Col md={4}>
              <Checkbox
                name='hsDiploma'
                onChange={() => this.handleToggle('hsDiploma')}
                checked={hsDiploma}
              >
                High School Diploma
              </Checkbox>
              <Checkbox
                name='hsGed'
                onChange={() => this.handleToggle('hsGed')}
                checked={hsGed}
              >
                High School GED
              </Checkbox>
              <Checkbox
                name='hsForeignDiploma'
                onChange={() => this.handleToggle('hsForeignDiploma')}
                checked={hsForeignDiploma}
              >
                Foreign High School Diploma
              </Checkbox>
            </Col>
          </Row>
          <hr />
          <h4>College</h4>
          <FormGroup
            controlId='educational-goal'
            validationState={validationStatus.educationalGoal}
          >
            <ControlLabel>
              Educational Goal
            </ControlLabel>
            <Row>
              {educationalGoalOptions.map((option, index) => {
                return (
                  <Col sm={3} md={2} key={index}>
                    <Checkbox
                      inline
                      onChange={() => this.handleToggle(option.value)}
                      checked={this.props[option.value]}
                    >
                      {option.text}
                    </Checkbox>
                  </Col>
                )
              })
              }
            </Row>
          </FormGroup>
          <Row>
            <Col md={6}>
              <FormGroup
                controlId='college-major'
                validationState={validationStatus.collegeMajor}>
                <ControlLabel>
                  College Major
                </ControlLabel>
                <FormControl
                  componentClass="input"
                  name='collegeMajor'
                  type="text"
                  value={collegeMajor}
                  placeholder="College Major"
                  onChange={this.handleChange} />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={6}> {/* College Units */}
            <FormGroup
              controlId='college-units'
              validationState={validationStatus.collegeUnits}>
              <ControlLabel>
                Total College Units Completed (do not include currently enrolled units)
              </ControlLabel>
              <FormControl
                componentClass="input"
                name='collegeUnits'
                type="text"
                value={collegeUnits}
                placeholder="Complete College Units"
                onChange={this.handleChange} />
              <FormControl.Feedback />
              </FormGroup>
            </Col> {/* College Units */}
          </Row>
          <Row>
            <Col lg={6}>
              <h4>Other Colleges <small>Please list any previous colleges you have attended</small></h4>
              {renderColleges()}
              {!readOnly &&
              <Button onClick={this.props.onAddCollege}
                      bsStyle="default"
                      className="pull-left">
                <Glyphicon glyph="plus"/>
                {space} Add {colleges.length > 0 ? 'Additional' : '' } College
              </Button>
              }
            </Col>
            <Clearfix visibleMdBlock visibleSmBlock visibleXsBlock />
            <Col lg={6}>
              <h4>Degrees <small>Please list any college degrees you have obtained</small></h4>
              {renderDegrees()}
              {!readOnly &&
              <Button onClick={this.props.onAddDegree}
                      bsStyle="default"
                      className="pull-left">
                <Glyphicon glyph="plus"/>
                {space} Add {degrees.length > 0 ? 'Additional' : '' } Degree
              </Button>
              }
            </Col>
          </Row>
        {!readOnly && validationStatus.section.status !== statusTypes.SUCCESS &&
        <FormSectionStatus {...validationStatus.section}/>
        }
        </Panel.Body>
      </Panel>
    )
  }
}

export default EducationInfo